<template>
    <div class="page">

        <header>
            <img src="../../../../assets/key/key.png" alt="">
            <strong>租客</strong>
        </header>

        <main>
            <list-item1 v-for="data in renters"
                        :key="data.userID"
                        :data-info="data">
            </list-item1>
        </main>

        <header class="visitor">
            <img src="../../../../assets/key/key.png" alt="">
            <strong>访客</strong>
        </header>

        <main>
            <list-item v-for="data in visitors"
                        :bind-name="bindName"
                        :rent-end="rentEnd"
                        v-on:delete-item="getInfo"
                        :lease-i-d="leaseID"
                        :key="data.userID"
                        :orgID = orgID
                        :data-info="data">
            </list-item>
        </main>
    </div>
</template>

<script>
    import ListItem from "./ListItem";
    import axios from "axios";
    import ListItem1 from "./ListItem1";

    export default {
        name: "List",

        components: {
            ListItem1,
            ListItem
        },

        data() {
            return {
                renters: [],
                visitors: [],

                bindName: "",
                rentEnd: "",
                leaseID: "",
                devID:"",
                bindID:"",
                orgID:"",
            }
        },

        created() {
            document.title = "分享记录"; 

            let data = JSON.parse(decodeURI(this.$route.query.data));
            document.title = data.bindName;

            this.bindName = data.bindName;
            this.leaseID = data.leaseID;
            this.devID = data.devID;
            this.bindID = data.bindID;
            this.orgID = data.orgID;

            this.getInfo();

             localStorage.setItem("token", this.$route.query.token || "");
            localStorage.setItem("orgID", data.orgID || "");
            localStorage.setItem("type", this.$route.query.client || "");
        },

        methods: {
            getInfo() {
                let url = axios.defaults.baseURL.replace('v1/org/','')
                axios({
                    method: 'post',
                    url: url+"v2/mkeys/users",
                    headers: {
                         'Authorization': this.$route.query.token,
                        'PYDDot-Client-Type':this.$route.query.client,
                        'X-Ca-Timestamp':parseInt(new Date().getTime()/1000)
                    },
                    data: { 
                        'bindID':this.bindID,
                        'devID':this.devID,
                        'orgID':this.orgID
                    },
                }).then(value => {
                    console.log(value.data)
                    if (value.data.data.renters) {
                        this.renters = value.data.data.renters;
                    }
                    if (value.data.data.visitors) {
                        this.visitors = value.data.data.visitors;
                    }
                    this.rentEnd = value.data.rentEnd;
                }).catch(() => {

                });
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../pay/page";

    header {
        width: 90%;
        border-radius: 10px;
        margin: 30px auto auto;
        padding-left: 14px;
        padding-right: 14px;
        align-items: center;
        color: white;
        box-sizing: border-box;
        background: $colorDefault;
        height: 44px;
        display: flex;
        img {
            margin-right: 10px;
            height: 22px;
            width: 22px;
        }
    }
    .visitor {
        background-color: orange;
    }

    main {
        margin-bottom: 40px;
    }
</style>
